export default function CTABanner() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/943c200d7181922574029782f116fb6d.jpeg"
          alt="Modern Australian property"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-navy-900/80" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="w-8 h-0.5 bg-gold-400" />
          <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Ready to Move In?</span>
          <div className="w-8 h-0.5 bg-gold-400" />
        </div>
        <h2 className="font-heading text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
          We Have Rooms Available Right Now
        </h2>
        <p className="text-white/70 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Browse our current vacancies and secure your fully furnished, all-inclusive room today. Flexible medium and long-term stays available across regional towns and metro cities in Australia.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://rentals.galaxyhousing.com.au"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-base px-10 py-4 rounded transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line" />
            </div>
            View Available Rentals
          </a>
          <a
            href="tel:0483944617"
            className="flex items-center gap-3 border border-white/40 hover:border-white text-white font-medium text-base px-10 py-4 rounded transition-all duration-200 cursor-pointer whitespace-nowrap hover:bg-white/10"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line" />
            </div>
            0483 944 617
          </a>
        </div>
      </div>
    </section>
  );
}
